function t(e) {
  return e != null && typeof e == "object";
}
var i = t;
export {
  i
};
